export default {
    OLYMP: '@_get_olympiad results',
};
